import { getStorageItem } from '@story/utils/localstorage';
import { SELECTED_TEMPLATE, LOCKED_BY } from '@story/constants';
export const storyStore = {
    state: {
        storybookMode: false,
        showSaveTemplateModal: false,
        showLoadTemplateModal: false,
        showLoadHostModal: false,
        selectedTemplate: getStorageItem(SELECTED_TEMPLATE) || null,
        templateOptions: [],
        hostOptions: [],
        lockedBy: getStorageItem(LOCKED_BY) || null,
    },
    setStorybookMode(isStorybookMode) {
        this.state.storybookMode = isStorybookMode;
    },
    setTemplateOptions(options) {
        this.state.templateOptions = options;
    },
    setHostOptions(options) {
        this.state.hostOptions = options;
    },
};
